module.exports = __webpack_public_path__ + "img/laina.fi.f6c2bf0.png";